import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { TuiButtonModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { TuiInputModule, TuiInputPasswordModule } from '@taiga-ui/kit';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  BehaviorSubject,
  catchError,
  filter,
  map,
  of,
  Subject,
  switchMap,
  tap,
} from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '@shared/services/auth.service';
import { AlertService } from '@shared/services/alert.service';

@Component({
  selector: 'app-user-verify-email-form',
  standalone: true,
  imports: [
    AsyncPipe,
    TranslocoPipe,
    TuiButtonModule,
    TuiInputModule,
    TuiInputPasswordModule,
    ReactiveFormsModule,
    TuiTextfieldControllerModule,
  ],
  templateUrl: './user-verify-email-form.component.html',
  styleUrl: './user-verify-email-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserVerifyEmailFormComponent implements OnInit {
  loading$ = new BehaviorSubject(false);
  submit$ = new Subject<void>();
  email = this.fb.control('', [Validators.email, Validators.required]);
  constructor(
    private readonly fb: FormBuilder,
    private readonly destroyRef: DestroyRef,
    private readonly auth: AuthService,
    private readonly alert: AlertService,
  ) {}

  ngOnInit() {
    this.submit$
      .pipe(
        filter(() => !this.email.invalid),
        map(() => this.email.getRawValue()),
        tap(() => this.loading$.next(true)),
        switchMap(email =>
          this.auth.sendRegistrationRequest(email!).pipe(
            tap(() => {
              this.loading$.next(false);
              this.alert.showSuccess();
            }),
            catchError(err => {
              this.alert.showError(err.error);
              this.loading$.next(false);
              return of(null);
            }),
          ),
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
